export const containerStyles =
   'flex flex-row items-start gap-x-[12px] ml-auto max-w-full overflow-hidden'

export const queryContainerStyles =
   'relative px-[12px] rounded-[12px] w-full flex-1  overflow-auto'

export const loaderContainer = 'flex flex-row gap-3'
export const loadingTextAndLottieContainer =
   'flex items-center border border-gray-300 rounded-[12px] pl-3'

export const scrollableContainerStyles =
   'overflow-x-auto max-w-full ai-chat-query-container mb-[24px]'
